import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m10.06 99.61 181.84-67.6L192 416 22 478.8c-10.51 4.3-22-3.5-22-14.8V114.5c0-6.6 3.984-12.5 10.06-14.89M576 48.02V397.6c0 6.5-4 11.5-10.1 14.8L384 480V96.01l170-62.85c10.6-4.2 22 3.54 22 14.86",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1),
    _createElementVNode("path", {
      d: "m192 32 192 64v384l-191.9-64z",
      style: {"fill":"var(--fa-secondary-color, currentColor)","opacity":"var(--fa-secondary-opacity, 0.4)"}
    }, null, -1)
  ])))
}
export default { render: render }